export const STUDENT_APP_URL = `${process.env.REACT_APP_SERVER_URL}/applications`;

export const PARENT_APP_URL = `${process.env.REACT_APP_SERVER_URL}/parents-applications`;
